import { useIndustryTransitionModalStore } from "../store/useIndustryTransitionModalStore";

import { IndustryTransitionImpactReportModalContainer } from "./IndustryTransitionImpactReportModalContainer";

/**
 * Mounted once at the SI root rather than inside the banners that open it: those hide themselves the
 * moment enrolling flips the opt-in, which would unmount the success screen mid-read. Mounting only
 * while open also keeps the report request off every page load and leaves no state to reset.
 */
export const IndustryTransitionModalHost = () => {
    const isOpen = useIndustryTransitionModalStore((state) => state.isOpen);

    return isOpen ? <IndustryTransitionImpactReportModalContainer /> : null;
};
